import { useState, useEffect } from 'react';
import TripHeader from './TripHeader';
import DaysList from './DaysList';
import DayDetail from './DayDetail';
import { Stop, CalendarDay } from '../types';
import { loadJSON } from '../utils/dataLoader';
import { useAppState } from '../state/store';
import './ItineraryRail.css';

interface ItineraryRailProps {
  onStopClick: (stop: Stop) => void;
}

export default function ItineraryRail({ onStopClick }: ItineraryRailProps) {
  const [stops, setStops] = useState<Stop[]>([]);
  const [calendar, setCalendar] = useState<CalendarDay[]>([]);
  const { selectedDay, setSelectedDay } = useAppState();

  useEffect(() => {
    Promise.all([
      loadJSON<Stop[]>('/data/dist/stops.json', { useGzip: true }),
      loadJSON<CalendarDay[]>('/data/dist/calendar.json', { useGzip: true }),
    ]).then(([stopsData, calendarData]) => {
      setStops(stopsData);
      setCalendar(calendarData);
    }).catch(err => {
      console.error('Failed to load itinerary data:', err);
    });
  }, []);

  const handleDayClick = (day: string) => {
    setSelectedDay(day);
  };

  const handleBack = () => {
    setSelectedDay(null);
  };

  return (
    <div className="itinerary-rail">
      {selectedDay ? (
        <>
          <div className="day-view-header">
            <div className="back-button-container">
              <button className="back-button" onClick={handleBack}>
                ← Back to All Days
              </button>
            </div>
          </div>
                 <DayDetail
                   day={selectedDay}
                   calendar={calendar}
                   stops={stops}
                   onStopClick={onStopClick}
                   onDayChange={setSelectedDay}
                 />
        </>
      ) : (
        <>
          <TripHeader calendar={calendar} />
          <DaysList calendar={calendar} onDayClick={handleDayClick} />
        </>
      )}
    </div>
  );
}

